import { motion } from "framer-motion";
import { useLang } from "@/lib/lang";

export const FadeUp = ({ children, delay = 0, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay, ease: "easeOut" }}
        className={className}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "center" }) => (
    <FadeUp
        className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-14 md:mb-20`}
    >
        <span className="inline-block rounded-full border border-orange-500/30 bg-orange-500/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-amber-400">
            {eyebrow}
        </span>
        <h2 className="mt-5 text-3xl font-bold tracking-tight text-slate-50 md:text-4xl">
            {title}
        </h2>
        {subtitle && (
            <p className="mt-4 text-base leading-relaxed text-zinc-400 md:text-lg">{subtitle}</p>
        )}
    </FadeUp>
);

export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
    </svg>
);

export const ThreadsIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className} aria-hidden="true">
        <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9Z" />
        <path d="M15.5 10.5c-.5-1.5-1.8-2.5-3.5-2.5-2 0-3.5 1.5-3.5 4s1.5 4 3.5 4c1.8 0 3-1 3.4-2.5.2-.9-.3-2-1.4-2.5-1.3-.6-3-.3-3.7.5" />
    </svg>
);

export const LangPill = ({ className = "" }) => {
    const { lang, setLang } = useLang();
    return (
        <div
            className={`flex rounded-full border border-white/15 bg-white/5 p-1 ${className}`}
            role="group"
            aria-label="Pilih bahasa"
        >
            {["id", "en"].map((l) => (
                <button
                    key={l}
                    type="button"
                    data-testid={`lang-${l}-button`}
                    onClick={() => setLang(l)}
                    className={`rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wider transition-colors duration-200 ${
                        lang === l ? "btn-flame text-white" : "text-zinc-400 hover:text-amber-300"
                    }`}
                >
                    {l}
                </button>
            ))}
        </div>
    );
};
